<div class="dropdown" dropdown>
    <a dropdownToggle class="active dropdown-toggle" id="dropdownMenuButton"
       aria-controls="dropdown-basic">
        <span><img [src]="'assets/images/'+isActiveLanguage+'.png'" class="flag" [alt]="languageName"></span>
    </a>
    <div *dropdownMenu
         class="dropdown-menu dropdown-menu-right"
         role="menu"
         aria-labelledby="button-basic">
        <a class="dropdown-item"
           (click)="onChangeLanguage('en')">
            <img [src]="'assets/images/en.png'" class="flag" alt="English"> English
        </a>
        <a class="dropdown-item"
           (click)="onChangeLanguage('fr')">
            <img [src]="'assets/images/fr.png'" class="flag" alt="French"> French
        </a>
        <a class="dropdown-item"
           (click)="onChangeLanguage('es')">
            <img [src]="'assets/images/es.png'" class="flag" alt="Spanish"> Spanish
        </a>
    </div>
</div>